module.exports = __webpack_public_path__ + "static/media/image-5.3f0129d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/image-5.jpg
// module id = 282
// module chunks = 0